import { isKeyEscape } from '@outbook/a11y';

export function LanguageMenu() {
  const root = document.querySelector(
    '[data-test-id="language-switcher"] .language-menu'
  );
  if (!(root instanceof HTMLDetailsElement)) {
    return;
  }

  const summary = root.querySelector('[data-test-id="language-menu-toggle"]');
  if (!(summary instanceof HTMLElement)) {
    return;
  }

  const close = () => {
    root.open = false;
  };

  document.addEventListener('click', event => {
    if (!root.open || root.contains(event.target)) {
      return;
    }
    close();
  });

  document.addEventListener('keydown', event => {
    if (!isKeyEscape(event) || !root.open) {
      return;
    }
    close();
    summary.focus();
  });
}
